import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';

@Component({
  selector: 'app-chapter-practice-tab',
  templateUrl: './chapter-practice-tab.component.html',
  styleUrls: ['./chapter-practice-tab.component.css']
})
export class ChapterPracticeTabComponent implements OnInit {

  @Input() tabSubject:string;
  tabPracticeTopicData:any;
  @Input() InteractiveStoriesList:any ;

  pypData:any;
  
  popularBookData = [
    {
      cover:'NCERT-Physics.png',
      title:'NCERT Books',
    },
    {
      cover:'RD-Sharma-maths.png',
      title: 'R.D.Sharma Mathematics',
    },
  ]

  constructor(public selfLearnService:SelfLearnService, public router:Router) { }

  ngOnInit(): void {
    this.getExamBanners();
    this.getTopicsByChapterExamSubtenant();
    this.setPreviousPageIfFromPracticeTopics();
  }

  getTopicsByChapterExamSubtenant(){
    this.selfLearnService.getTopicsByChapterExamSubtenant().subscribe((resp:any) => {
      this.tabPracticeTopicData = resp?.data;
      this.getPracticeProgress();

    })
  }

  getPracticeProgress(){
    this.selfLearnService.getPracticeProgress().subscribe((resp:any) => {
      if(resp?.data == null) return;
      this.tabPracticeTopicData = this.tabPracticeTopicData.map((item:any, row:any) => {
      let found = resp?.data?.find((element:any) => item.topicId == element.topicId);
      if(!found){found = {};found['levelsInProgress'] = 0; found['levelsCompleted'] = 0}
      else if(!found.levelsInProgress){found.levelsInProgress = 0}
        return {...item, ...found};
      });
      console.log(this.tabPracticeTopicData);
    })
  }

  setPreviousPageIfFromPracticeTopics(){
    const previousPage = localStorage.getItem("selfLearnPreviousPage");
    if(previousPage == 'practiceTopics'){localStorage.setItem("selfLearnPreviousPage", "chapters")}
  }

  navigateToPracticeTopics(){
    localStorage.setItem('selfLearnPreviousPage' , 'practiceTopics');
    this.router.navigateByUrl('selfLearn-V2/practice-topics');
  }
  getExamBanners(){
    this.selfLearnService.getBannerForExams().subscribe((res:any) => {
      this.pypData = res.data;
      console.log(res);
    })
  }

}
